<template>
  <div class="first-month-promotion">
    <i class="icon"></i>
    <h1 class="title" v-html="title"></h1>
    <p class="description" v-html="description"></p>
    <div class="table">
      <dl>
        <dt>1개월 차</dt>
        <dd>{{ price }}원</dd>
      </dl>
      <dl class="promotion-target">
        <dt>2개월 차</dt>
        <dd>100원</dd>
      </dl>
      <dl>
        <dt>3개월 차 이후</dt>
        <dd>{{ price }}원</dd>
      </dl>
    </div>
    <ul class="notice">
      <li>{{ notification }}</li>
    </ul>
    <div class="button-area">
      <button class="button-cancel" @click="closeLayerPopup">취소</button>
      <button class="button" type="button" @click="onClickProcess">
        이용권 구매
      </button>
    </div>
  </div>
</template>
<script setup>
  import { defineProps, computed } from 'vue'
  import { getTextBreaks } from '@/common/util/string-manipulation/get-text-breaks'
  import { EventBus } from '@/components/eventbus/EventBus'
  import {
    FIRST_MONTH_PROMOTION_CONFIRM,
    FIRST_MONTH_PROMOTION_LAYER_POPUP,
  } from '@/common/resources/const'
  import { setNumberComma } from '@/common/util/set-number-comma'

  const props = defineProps({
    payloads: {
      type: Object,
      default: () => ({}),
    },
  })

  const title = getTextBreaks(`한 달 100원 프로모션 혜택 적용 안내`)
  const description = `월별 자동결제 가격 안내`
  const notification = `이용권 변경, 환불 또는 자동결제 해지 시, 2개월 차 100원 혜택이 제공되지 않습니다.`
  const voucherInfo = computed(() => props.payloads?.voucherInfo ?? {})
  const price = computed(
    () => setNumberComma(voucherInfo.value?.productInfo?.amount) ?? '',
  )

  const onClickProcess = () => {
    EventBus.$emit(FIRST_MONTH_PROMOTION_CONFIRM, {
      isSuccess: true,
      payloads: props.payloads,
    })
  }

  const closeLayerPopup = () => {
    EventBus.$emit(FIRST_MONTH_PROMOTION_LAYER_POPUP, { isOpen: false })
  }
</script>
<style scoped lang="scss">
  .first-month-promotion {
    margin-top: 40px;
    padding: 12px;
    .icon {
      display: block;
      margin: 0 auto;
      border: none;
      width: 92px;
      height: 92px;
      background: url('~@/assets/images/ico_check.png') no-repeat center / cover;
    }
    .title {
      margin-top: 40px;
      color: #fff;
      font-size: 20px;
      font-weight: 400;
      line-height: 1.4;
      text-align: center;
    }
    .description {
      margin-top: 40px;
      color: #fff;
      font-size: 14px;
      line-height: 1.42;
      text-align: center;
    }
    .table {
      margin-top: 20px;
      dl {
        padding: 20px;
        border: 1px solid #2f2f2f;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        dt {
          color: #a5a5a5;
          font-size: 12px;
          line-height: 1.5;
        }
        dd {
          color: #a5a5a5;
          font-size: 16px;
          font-weight: 400;
          line-height: 1.5;
        }
        & + dl {
          margin-top: 8px;
        }
        &.promotion-target {
          border-color: #a5a5a5;
          dt {
            color: #fff;
          }
          dd {
            color: #fff;
            font-size: 16px;
            font-weight: 700;
            line-height: 1.5;
          }
        }
      }
    }
    .notice {
      margin-top: 20px;
      padding-bottom: 196px;
      font-size: 12px;
      line-height: 1.5;
      font-weight: 400;
      color: #5e5e5e;
      > li {
        position: relative;
        padding-left: 6px;
        &:before {
          content: '';
          position: absolute;
          top: 8px;
          left: 0;
          width: 2px;
          height: 2px;
          background-color: #5e5e5e;
          border-radius: 50%;
        }
      }
    }
    .button-area {
      position: fixed;
      bottom: 0;
      left: 50%;
      width: 100%;
      transform: translate(-50%, 0);
      padding: 0 12px 28px 12px;
      background-color: #1b1b1b;
      [class^='button'] {
        display: block;
        width: 100%;
        padding: 12px 0;
        border-radius: 30px;
        font-weight: 400;
        font-size: 16px;
        line-height: 1.5;
        color: #fff;
      }
      .button {
        margin-top: 8px;
        background-color: #0050ff;
      }
      .button-cancel {
        background-color: #2f2f2f;
      }
    }
  }
</style>
